/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Column_ColleagueInputs */



/**
* | output |
* | --- |
* | "Colleague" |
*
* @param {Team_Column_ColleagueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_column_colleague = /** @type {((inputs?: Team_Column_ColleagueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Column_ColleagueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Collega")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collègue")
	return /** @type {LocalizedString} */ ("Colleague")
});